export const ActionTypes = {
  SET_LOADER_STATUS: 'services/dashboards/silosAssignmentDashboard/set_loader_status',
  FETCH_SILOS_ASSIGNMENT_GRID:
    'services/dashboards/silosAssignmentDashboard/fetch_silos_assignment_grid',
  SET_SILOS_ASSIGNMENT_GRID:
    'services/dashboards/silosAssignmentDashboard/set_silos_assignment_grid',
  ADD_OR_UPDATE_ASSIGNMENT: 'services/dashboards/silosAssignmentDashboard/add_or_update_assignment',
  ALLOCATE_RAW_MATERIAL: 'services/dashboards/silosAssignmentDashboard/allocate_raw_material',
  FETCH_ALLOCATED_RAW_MATERIAL:
    'services/dashboards/silosAssignmentDashboard/fetch_allocated_raw_material',
  SET_ALLOCATED_RAW_MATERIAL:
    'services/dashboards/silosAssignmentDashboard/set_allocated_raw_material',
  DELETE_ALLOCATED_RAW_MATERIAL:
    'services/dashboards/silosAssignmentDashboard/delete_allocated_raw_material',
  COMPLETE_ASSIGNMENT: 'services/dashboards/silosAssignmentDashboard/complete_assignment',
  DELETE_ASSIGNMENT: 'services/dashboards/silosAssignmentDashboard/delete_assignment',
  FETCH_MATERIAL_CONSUMPTION:
    'services/dashboards/silosAssignmentDashboard/fetch_material_consumption',
  SET_MATERIAL_CONSUMPTION: 'services/dashboards/silosAssignmentDashboard/set_material_consumption',
  DELETE_MATERIAL_CONSUMPTION:
    'services/dashboards/silosAssignmentDashboard/delete_material_consumption',
};
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const fetchSilosAssignmentGrid = ({ siloAssignmentParams }) => ({
  siloAssignmentParams,
  type: ActionTypes.FETCH_SILOS_ASSIGNMENT_GRID,
});

const addOrUpdateAssignment = ({ assignmentData, actionName, siloAssignmentParams }) => ({
  assignmentData,
  actionName,
  siloAssignmentParams,
  type: ActionTypes.ADD_OR_UPDATE_ASSIGNMENT,
});

const allocateRawMaterial = ({ actionName, allocationData }) => ({
  actionName,
  allocationData,
  type: ActionTypes.ALLOCATE_RAW_MATERIAL,
});

const fetchAllocatedRawMaterial = ({ materialAllocationParams }) => ({
  materialAllocationParams,
  type: ActionTypes.FETCH_ALLOCATED_RAW_MATERIAL,
});

const setSilosAssignmentGrid = ({ siloAssignmentGrid }) => ({
  siloAssignmentGrid,
  type: ActionTypes.SET_SILOS_ASSIGNMENT_GRID,
});

const setAllocatedRawMaterial = ({ materialAllocations }) => ({
  materialAllocations,
  type: ActionTypes.SET_ALLOCATED_RAW_MATERIAL,
});

const deleteAllocatedRawMaterial = ({ allocatedMaterial }) => ({
  allocatedMaterial,
  type: ActionTypes.DELETE_ALLOCATED_RAW_MATERIAL,
});

const completeAssignment = ({ assignment }) => ({
  assignment,
  type: ActionTypes.COMPLETE_ASSIGNMENT,
});

const deleteAssignment = ({ assignment }) => ({
  assignment,
  type: ActionTypes.DELETE_ASSIGNMENT,
});

const fetchMaterialConsumption = ({ materialConsumptionParams }) => ({
  materialConsumptionParams,
  type: ActionTypes.FETCH_MATERIAL_CONSUMPTION,
});

const setMaterialConsumption = ({ materialConsumptions }) => ({
  materialConsumptions,
  type: ActionTypes.SET_MATERIAL_CONSUMPTION,
});

const deleteMaterialConsumption = ({ materialConsumption }) => ({
  materialConsumption,
  type: ActionTypes.DELETE_MATERIAL_CONSUMPTION,
});

export default {
  setLoader,
  fetchSilosAssignmentGrid,
  setSilosAssignmentGrid,
  addOrUpdateAssignment,
  allocateRawMaterial,
  fetchAllocatedRawMaterial,
  setAllocatedRawMaterial,
  deleteAllocatedRawMaterial,
  completeAssignment,
  deleteAssignment,
  fetchMaterialConsumption,
  setMaterialConsumption,
  deleteMaterialConsumption,
};
